import Lottie from 'lottie-react'
import IconStatusBarFailed from '~/assets/images/statusBar-failed.svg'
import IconStatusBarPending from '~/assets/images/statusBar-pending.svg'
import IconStatusBarSuccess from '~/assets/images/statusBar-success.svg'
import IconInstantAppStatusBarSuccess from '~/assets/images/instant-app-statusBar-success.svg'
import IconInstantWebStatusBarSuccess from '~/assets/images/instant-web-statusBar-success.svg'
import IconInstantAppStatusBarFailed from '~/assets/images/instant-app-statusBar-failed.svg'
import IconInstantWebStatusBarFailed from '~/assets/images/instant-web-statusBar-failed.svg'
import { isFailed, isInProgress, isSuccess } from '../../helper'
import leftLoading from '../../json/leftLoading.min.json'
import rightLoading from '../../json/rightLoading.min.json'
import instantWebLeftLoading from '../../json/instantWebLeftLoading.json'
import instantWebRightLoading from '../../json/instantWebRightLoading.json'
import instantAppLeftLoading from '../../json/instantAppLeftLoading.json'
import instantAppRightLoading from '../../json/instantAppRightLoading.json'
import { TRADE_STATUS, TRADE_TYPE } from '../../types'
import { useBreakpoint } from '~/hooks'

interface Props {
  status: TRADE_STATUS
  tradeType?: TRADE_TYPE
}

const renderLoading = (status: TRADE_STATUS, tradeType: TRADE_TYPE) => {
  const { isBreakPointSM } = useBreakpoint()

  const instantLeftLoading = isBreakPointSM
    ? instantAppLeftLoading
    : instantWebLeftLoading
  const instantRightLoading = isBreakPointSM
    ? instantAppRightLoading
    : instantWebRightLoading

  const leftLoadingJson =
    tradeType === TRADE_TYPE.INSTANT ? instantLeftLoading : leftLoading
  const rightLoadingJson =
    tradeType === TRADE_TYPE.INSTANT ? instantRightLoading : rightLoading

  if (isInProgress(status)) {
    const animation =
      status === TRADE_STATUS.PENDING ? rightLoadingJson : leftLoadingJson
    return (
      <Lottie
        animationData={animation}
        autoPlay
        loop
        style={{ display: 'flex', flex: 1 }}
      />
    )
  }
  return null
}

const renderCompleted = (status: TRADE_STATUS, tradeType: TRADE_TYPE) => {
  const { isBreakPointSM } = useBreakpoint()

  const isInstant = tradeType === TRADE_TYPE.INSTANT
  const InstantStatusBarSuccess = isBreakPointSM
    ? IconInstantAppStatusBarSuccess
    : IconInstantWebStatusBarSuccess

  const InstantStautsBarFailed = isBreakPointSM
    ? IconInstantAppStatusBarFailed
    : IconInstantWebStatusBarFailed

  const StatusBarSuccess = isInstant
    ? InstantStatusBarSuccess
    : IconStatusBarSuccess

  const StatusBarFailed = isInstant
    ? InstantStautsBarFailed
    : IconStatusBarFailed

  if (isInProgress(status)) {
    return null
  }
  if (isFailed(status)) {
    return <img src={StatusBarFailed} />
  }
  const statusImage = isSuccess(status) ? (
    <img src={StatusBarSuccess} />
  ) : (
    <img src={IconStatusBarPending} />
  )
  return statusImage
}

const StatusBar: React.FC<Props> = ({
  status,
  tradeType = TRADE_TYPE.STAKING,
}) => {
  const isInstant = tradeType === TRADE_TYPE.INSTANT
  return (
    <div className={`status-bar ${isInstant && 'instant'}`}>
      {renderLoading(status, tradeType)}
      {renderCompleted(status, tradeType)}
    </div>
  )
}

export default StatusBar
